import TableCell from '@mui/material/TableCell';
import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import { HomePageResponseViewModel } from 'types/home-page';

import { HomePageListCell } from './HomePageListCell';

interface Props {
    columns: ITableHeadCell[];
    rowData: HomePageResponseViewModel;
    onSetAsActive: (id: string) => void;
}

export const HomePageListRow = ({ columns, ...props }: Props) => (
    <>
        {columns.map((item) => (
            <TableCell id={item.id} key={item.field}>
                <HomePageListCell item={item} {...props} />
            </TableCell>
        ))}
    </>
);
